import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "fields"]

  connect() {
    this.update()
  }

  update() {
    const showFields = this.toggleTarget.checked

    this.fieldsTarget.classList.toggle("hidden", !showFields)
    this.fieldsTarget.setAttribute("aria-hidden", (!showFields).toString())

    this.fieldsTarget.querySelectorAll("input, select, textarea").forEach((field) => {
      if (field.dataset.businessDetailsRequired == null && "required" in field) {
        field.dataset.businessDetailsRequired = field.required ? "true" : "false"
      }

      field.disabled = !showFields
      if ("required" in field) {
        field.required = showFields && field.dataset.businessDetailsRequired === "true"
      }
    })
  }
}
